import { NgModule, APP_INITIALIZER }      from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { GridModule } from '@progress/kendo-angular-grid';

import { HttpModule } from '@angular/http';

//import { CookieModule } from 'ngx-cookie';
import { AuthorizationService } from './services/authorization.service';
import { EnvironmentService } from '../services/environment.service';

import { SidebarModule } from 'ng-sidebar';

// Import the ButtonsModule...
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { PanelModule } from 'primeng/primeng';

import { LegendaryAppComponent } from './legendary-app.component';
import { RandomizerFormComponent } from './legendary/randomizer-form.component';
import { LegendaryGameComponent } from './legendary/legendary-game.component';
import { LegendaryGame } from './legendary/legendary-game.interface';
import { LegendarySettingsComponent } from './settings/legendary-settings.component';
import { EncountersFormComponent } from './encounters/encounters-form.component';
import { EncountersGameComponent } from './encounters/encounters-game.component';
import { EncountersGame } from './encounters/encounters-game.interface';

import { LegendaryCustomComponent } from './custom/legendary-custom.component';
import { CustomMastermindComponent } from './custom/custom-mastermind.component';
import { CustomMastermindEditComponent } from './custom/custom-mastermind-edit.component';

import { CustomHeroesComponent } from './custom/custom-heroes.component';
import { CustomHeroEditComponent } from './custom/custom-hero-edit.component';

import { CustomVillainComponent } from './custom/custom-villain.component';
import { CustomVillainEditComponent } from './custom/custom-villain-edit.component';

import { CardService } from './services/card.service';
import { LegendaryService } from './services/legendary.service';

import { AdsenseModule } from 'ng2-adsense';

@NgModule({
    declarations: [
        LegendaryAppComponent,
        RandomizerFormComponent,
        LegendaryGameComponent,
        LegendarySettingsComponent,
        EncountersFormComponent,
        EncountersGameComponent,
        LegendaryCustomComponent,
        CustomMastermindComponent,
        CustomMastermindEditComponent,
        CustomHeroesComponent,
        CustomHeroEditComponent,
        CustomVillainComponent,
        CustomVillainEditComponent
    ],
  imports: [
      BrowserModule,
      BrowserAnimationsModule,
      //FormsModule,
      ReactiveFormsModule,
      HttpModule,
      GridModule,
      DialogModule,
      InputsModule,

      // ... and register it
      ButtonsModule,
      DropDownsModule,
      LayoutModule,
      InputsModule,
      PanelModule,

      SidebarModule.forRoot(),
      AdsenseModule.forRoot({
          adClient: 'a-pub-5731932096088693',
          adSlot: 9653559293
      }),
    ],
  providers: [
      AuthorizationService,
      EnvironmentService,
      CardService,
      LegendaryService,
      {
          provide: APP_INITIALIZER,
          useFactory:
          (authorizationService: AuthorizationService) => {
              return () => authorizationService.fetchToken();
          },
          deps: [AuthorizationService],
          multi: true
      }
  ],
  bootstrap:    [ LegendaryAppComponent ]
})
export class LegendaryAppModule { }


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./Apps/legendary/legendary-app.module.ts